import React from "react";
import { ProgressIndicator } from "@ftdr/blueprint-components-react";
import { StyleType } from "../../../../../types";
import { progressIndicatorColorMap } from "../../../../../const";

export interface LoadingSpinnerProps {
  styleType: StyleType;
}
export const LoadingSpinner = ({
  styleType,
}: LoadingSpinnerProps): JSX.Element => {
  return (
    <ProgressIndicator
      className="my-4"
      size="medium"
      color={progressIndicatorColorMap[styleType || "default"]}
    />
  );
};
